import script from "./TextAnalysis.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextAnalysis.vue?vue&type=script&lang=ts&setup=true"

import "./TextAnalysis.vue?vue&type=style&index=0&id=131806ce&lang=less"

const __exports__ = script;

export default __exports__